// Resumen del dashboard: conteos + presentaciones fabricadas + alertas +
// últimos movimientos. Equivale a DashboardService.resumen del backend viejo.
import { insforge } from '../insforge';
import { listarAlertas } from './alertas';
import type { DashboardResumen, Movimiento } from '../../types';

async function contar(tabla: string): Promise<number> {
  const { count, error } = await insforge.database.from(tabla).select('*', { count: 'exact', head: true });
  if (error) throw new Error(error.message);
  return count ?? 0;
}

export async function resumenDashboard(): Promise<DashboardResumen> {
  const [bodegas, productos, presentaciones, movimientos, invPres, alertas, recientes] = await Promise.all([
    contar('bodegas'),
    contar('productos'),
    contar('presentaciones'),
    contar('movimientos'),
    insforge.database.from('inventario').select('stock').eq('tipo', 'presentacion'),
    listarAlertas(),
    insforge.database.from('movimientos').select('*').order('created_at', { ascending: false }).limit(8),
  ]);
  if (invPres.error) throw new Error(invPres.error.message);
  if (recientes.error) throw new Error(recientes.error.message);

  const presentacionesDisponibles = ((invPres.data ?? []) as { stock: number }[]).reduce(
    (s, r) => s + Number(r.stock),
    0,
  );

  return {
    totales: {
      bodegas,
      productos,
      presentaciones,
      movimientos,
      presentacionesDisponibles,
      stockBajo: alertas.filter((a) => a.tipo === 'bajo').length,
      agotados: alertas.filter((a) => a.tipo === 'agotado').length,
    },
    movimientosRecientes: (recientes.data ?? []) as Movimiento[],
    alertas: alertas.slice(0, 6),
  };
}
